import actionConst from '../containers/Documents/constants/edit-document.constants';

const defaultState = {
	modalVisible: false,
	posted: false,
	updatedDocument: null,
	contractorId: undefined,
	postDocumentID: undefined,
	documentData: {}
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.RESET_POSTED_DOCUMENT: {
			return {
				...state,
				postDocumentID: null
			}
		}
		case actionConst.POST_DOCUMENT: {
			return {
				...state,
				postDocumentID: action.payload
			}
		}
		case actionConst.OPEN_MODAL: {
			return {
				...state,
				modalVisible: true,
				documentData: action.payload,
				posted: false,
			}
		}
		case actionConst.CLOSE_MODAL: {
			return {
				...state,
				modalVisible: false
			}
		}
		default:
			return state;
	}
}